import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { total, alert, toFixed, format_date, getStorage, replaceText } from "./CustomComponent.js";
import "../assets/css/bootstrap.css";
import "./global.js";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
  FCIconic: { normal: "FCIconic-Light.ttf", bold: "FCIconic-Bold.ttf", italics: "FCIconic-Italic.ttf", bolditalics: "FCIconic-Italic.ttf" },
  THSarabunNew: { normal: "THSarabunNew.ttf", bold: "THSarabunNew-Bold.ttf", italics: "THSarabunNew-Italic.ttf", bolditalics: "THSarabunNew-BoldItalic.ttf" },
  Roboto: { normal: "Roboto-Regular.ttf", bold: "Roboto-Medium.ttf", italics: "Roboto-Italic.ttf", bolditalics: "Roboto-MediumItalic.ttf" },
};

async function print(docDefinition) {
  pdfMake.createPdf(docDefinition).print();
}

async function open(docDefinition, filename = "รายงาน.pdf") {
  try {
    pdfMake.createPdf(docDefinition).open();
  } catch (error) {
    pdfMake.createPdf(docDefinition).download(filename);
    const msg = error === "Open PDF in new window blocked by browser" 
      ? "ไม่สามารถเปิดเอกสารได้เนื่องจากการปิดกั้นจากบราวเซอร์" 
      : "กรุณาลองใหม่อีกครั้ง";
    alert("warning", "แจ้งเตือน", msg);
  }
}

// พิมพ์รายงานรับโอนเงินประจำเดือน
async function report_remittance_3(data, start_date, type) {
  // คำนวณ total_final ของแต่ละรายการก่อน (mutate ลงในแต่ละ item)
  data.forEach((item) => {
    if (item.status_bill === 2) {
      // NOTE เดิมล้างไม่ครบ — add_on_* ไม่ถูกล้าง และบรรทัดถัดไปเซ็ต other_income กลับจาก record_other_list
      //      ทำให้ใบที่ยกเลิกยังโผล่ในคอลัมน์รายรับอื่นๆ/เพิ่มลดหนี้ และในยอดรวมท้ายตาราง
      //      ทั้งที่บรรทัด "สรุปฝากเข้าบัญชี" (ใช้ total_final) ตัดใบยกเลิกออกแล้ว — 2 ยอดจึงไม่ตรงกัน
      Object.assign(item, {
        water_bill: 0, equipment_maintenance_fee: 0, common_expenses: 0,
        waste_cost: 0, other_income: 0, fire_cost: 0, cable_cost: 0,
        add_debt: 0, reduce_debt: 0, meter_connect_cost: 0,
        late_payment: 0, change_satang: 0, total_final: 0,
        add_on_add_debt: 0, add_on_reduce_debt: 0
      });
    }

    item.count_bill = item.count_bill || 1;
    if (item.status_bill !== 2) item.other_income = item.record_other_list?.[0]?.cost ?? item.other_income;

    const totalOther = item.other_income + item.fire_cost + item.cable_cost;
    const debt = item.add_debt + (item.add_on_add_debt || 0) - (item.reduce_debt + (item.add_on_reduce_debt || 0));
    item.total_final =
      item.water_bill +
      item.equipment_maintenance_fee +
      item.common_expenses +
      item.waste_cost +
      totalOther +
      debt +
      item.meter_connect_cost +
      item.late_payment +
      item.change_satang;
  });

  const data_cash = data.filter((item) => item.payment_type === 1);
  const data_transfer = data.filter((item) => item.payment_type === 2);

  // ใช้ flatMap เพื่อสร้าง 2 แถวต่อ 1 รายการ
  const array = data.flatMap((item, i) => {
    const totalOther = item.other_income + item.fire_cost + item.cable_cost;
    const debt = item.add_debt + (item.add_on_add_debt || 0) - (item.reduce_debt + (item.add_on_reduce_debt || 0));
    const descText = item.status_bill === 2 ? "ยกเลิก" : 
      `ชำระ ${item.count_bill} รายการ ${item.payment_type === 2 ? "โอนเงินวันที่ " + format_date(item.transfer_date, "dd/mm/yyyy") : ""} ${item.rw_number}`;
    
    return [
      [
        { text: i + 1, rowSpan: 2, alignment: "center" },
        { text: item.iw_number, alignment: "center" },
        { text: item.address_number || item.address || "-", rowSpan: 2, alignment: "center" },
        { text: item.full_name, border: [true, true, true, false], alignment: "left" },
        { text: toFixed(item.water_bill), rowSpan: 2, alignment: "center" },
        { text: toFixed(item.equipment_maintenance_fee), rowSpan: 2, alignment: "center" },
        { text: toFixed(item.common_expenses), rowSpan: 2, alignment: "center" },
        { text: toFixed(item.waste_cost), rowSpan: 2, alignment: "center" },
        { text: toFixed(totalOther), rowSpan: 2, alignment: "center" },
        { text: toFixed(debt), rowSpan: 2, alignment: "center" },
        { text: toFixed(item.meter_connect_cost), alignment: "center" },
        { text: toFixed(item.late_payment), alignment: "center" },
        { text: toFixed(item.change_satang), alignment: "center" },
      ],
      [
        "", { text: format_date(item.record_date, "dd/mm/yyyy"), alignment: "center" }, "", 
        { text: descText, border: [true, false, true, true], noWrap: true },
        "", "", "", "", "", "", 
        { text: "รวมทั้งสิ้น", fillColor: "#C0C0C0" }, 
        { text: toFixed(item.total_final), fillColor: "#C0C0C0", colSpan: 2 }, ""
      ]
    ];
  });

  // สร้าง Helper ลดความยาวของการพิมพ์ total(data, "...")
  const t = (key) => total(data, key);
  const totalOtherSum = t("other_income") + t("fire_cost") + t("cable_cost");
  const totalDebtSum = t("add_debt") + t("add_on_add_debt") - (t("reduce_debt") + t("add_on_reduce_debt"));

  const docDefinition = {
    content: [
      { text: getStorage("project_name"), alignment: "left", fontSize: 18, bold: true },
      { text: `รายงาน${type === 1 ? "เงินสด" : "เงินโอน"}ที่ได้รับแจ้งและออกใบเสร็จรับเงินแล้ว ประจำเดือน` + format_date(start_date, "mmmm yyyy"), alignment: "left", fontSize: 14, bold: true },
      { text: " " },
      {
        table: {
          headerRows: 1,
          widths: ["3.10%", "12.16%", "5.18%", "16.24%", "8.34%", "7.34%", "8.16%", "4.56%", "7.16%", "5.06%", "7.06%", "8.16%", "6.54%"],
          body: [
            [
              { text: "ลำดับ", alignment: "center" }, { text: "เลขที่ใบเสร็จรับเงิน", alignment: "center" },
              { text: "บ้านเลขที่", alignment: "center" }, { text: "ชื่อ-นามสกุล", alignment: "center" },
              { text: "ค่าน้ำประปา", alignment: "center" }, { text: "ค่ารักษา อุปกรณ์น้ำ", alignment: "center" },
              { text: "ค่าส่วนกลาง", alignment: "center" }, { text: "ค่าขยะ", alignment: "center" },
              { text: "รายรับอื่นๆ", alignment: "center" }, { text: "เพิ่ม/ลดหนี้", alignment: "center" },
              { text: "ค่าต่อกลับ มิเตอร์", alignment: "center" }, { text: "ค่าปรับชำระล่าช้า", alignment: "center" },
              { text: "ปรับเศษ", alignment: "center" },
            ],
            ...array,
            [
              { text: "", rowSpan: 2, alignment: "center" }, " ", { text: " ", rowSpan: 2, alignment: "center" }, 
              { text: "รวมเป็นเงินทั้งสิ้น", rowSpan: 2, alignment: "right" }, 
              { text: toFixed(t("water_bill")), rowSpan: 2, alignment: "center" }, 
              { text: toFixed(t("equipment_maintenance_fee")), rowSpan: 2, alignment: "center" }, 
              { text: toFixed(t("common_expenses")), rowSpan: 2, alignment: "center" }, 
              { text: toFixed(t("waste_cost")), rowSpan: 2, alignment: "center" }, 
              { text: toFixed(totalOtherSum), rowSpan: 2, alignment: "center" }, 
              { text: toFixed(totalDebtSum), rowSpan: 2, alignment: "center" }, 
              { text: toFixed(t("meter_connect_cost")), alignment: "center" }, 
              { text: toFixed(t("late_payment")), alignment: "center" }, 
              { text: toFixed(t("change_satang")), alignment: "center" }
            ],
            [
              "", "", "", "", "", "", "", "", "", "", 
              { text: "รวมทั้งสิ้น", fillColor: "#C0C0C0" }, { text: toFixed(
                t("water_bill")+
t("equipment_maintenance_fee")+
t("common_expenses")+
t("waste_cost")+
totalOtherSum+
totalDebtSum+
t("meter_connect_cost")+
t("late_payment")+
t("change_satang")
              ), fillColor: "#C0C0C0", colSpan: 2 }, ""
            ],
            [{ text: "สรุปฝากเข้าบัญชีค่าน้ำและค่าส่วนกลาง", colSpan: 10, alignment: "right" }, "", "", "", "", "", "", "", "", "", { text: "เป็นเงิน", fillColor: "#C0C0C0" }, { text: toFixed(total(data_cash, "total_final")), fillColor: "#C0C0C0", colSpan: 2 }, ""],
            [{ text: "สรุปยอดโอนเงินเข้าบัญชีนิติ", colSpan: 10, alignment: "right" }, " ", "", "", "", "", "", "", "", "", { text: "เป็นเงิน", fillColor: "#C0C0C0" }, { text: toFixed(total(data_transfer, "total_final")), fillColor: "#C0C0C0", colSpan: 2 }, ""],
          ],
        },
      },
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 9, lineHeight: 0.9 },
    pageSize: "A4",
    pageMargins: [15, 15, 15, 15],
  };

  const textDocDefinition = await replaceText(docDefinition);
  open(textDocDefinition, `รายงาน${type === 1 ? "เงินสด" : "เงินโอน"}ที่ได้รับแจ้งและออกใบเสร็จรับเงินแล้ว ` + new Date().toISOString() + ".pdf");
}

export { report_remittance_3 };